import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';
import * as types from './types';
import config from '../../config/app_config';
import { getClient } from '../../common/utils';

export function* createPerkServiceWatcherSaga() {
  yield takeEvery(types.CREATE_PERK_SERVICE_CALL_REQUEST, workerSaga);
}

export function createData(data) {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/offer/${client}/perkservice/`;

  return axios.post(url, data)
    .then(val => val)
    .catch(err => err.response);
}

export function* workerSaga(action) {
  try {
    const { data } = action;
    const response = yield call(createData, data);

    if (response && response.status >= 200 && response.status < 202) {
      yield put({ type: types.CREATE_PERK_SERVICE_CALL_SUCCESS });
      yield put({ type: types.GET_PERK_SERVICE_CALL_REQUEST });
    } else {
      yield put({ type: types.CREATE_PERK_SERVICE_CALL_FAILURE, error: response && response.data });
    }
  } catch (error) {
    yield put({ type: types.CREATE_PERK_SERVICE_CALL_FAILURE, 'error': error && error.data});
  }
}
